export default __webpack_public_path__ + "static/media/CED-Logo-v2.1.84052fd6.png";